import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from '@/router'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: null,
        usuario: null,
        mensajes: {
            error500: 'Ocurrió un error en el servidor'
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
        },
        setUsuario(state, usuario) {
            state.usuario = usuario;
        }
    },
    actions: {
        guardarToken({commit}, token) {
            console.log('guardarToken decode token', decode(token));
            commit("setToken", token);
            commit("setUsuario", decode(token));
            localStorage.setItem("token", token)
        },
        autoLogin({commit}) {
            console.log('autoLogin');
            let token = localStorage.getItem("token");
            if (token) {
                console.log('autoLogin decode token', decode(token));
                console.log('token', token);
                commit("setToken", token);
                commit("setUsuario", decode(token));
                router.push({name: 'home'});
                console.log('Ruteando a home');
            }
        },
        salir({commit}) {
            commit("setToken", null);
            commit("setUsuario", null);
            localStorage.removeItem("token");
            router.push({name: 'login'});
        }
    },
    modules: {}
})
